import React from 'react';
import {WordList} from '../../domain/types';
import {BookIcon, GlobeIcon, StarIcon, TrashIcon} from '../Icons';

/**
 * The four things that can be true about a list, in the order a user cares about them.
 *
 * These were ⭐ 🗑 📚 👥 — emoji render differently on every platform and cannot take a colour from
 * their meaning, which is the entire job of a badge. Each one keeps its `title` so the meaning is
 * reachable without decoding the glyph.
 */
const WordListBadges: React.FC<{list: WordList}> = ({list}) => (
  <>
    {list.isOfficial && (
      <span title="Official list" className="shrink-0 text-amber-400">
        <StarIcon className="w-3.5 h-3.5" />
      </span>
    )}
    {list.isPublic && (
      <span title="Public — visible in the marketplace" className="shrink-0 text-emerald-400">
        <GlobeIcon className="w-3.5 h-3.5" />
      </span>
    )}
    {list.isOwner === false && (
      <span title="Added from the marketplace — you don’t own it" className="shrink-0 text-indigo-400">
        <BookIcon className="w-3.5 h-3.5" />
      </span>
    )}
    {list.isDeleted && (
      <span title="Deleted by its owner" className="shrink-0 text-red-400">
        <TrashIcon className="w-3.5 h-3.5" />
      </span>
    )}
  </>
);

export default WordListBadges;
